module.exports = __webpack_public_path__ + "static/media/badge.e3d049df.svg";